import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../config/axiosInstance';
import { updateAds } from "./authSlice";
import ENDPOINTS from '../../config/apiUrls';
// ================================================
// ASYNC THUNKS
// ================================================

export const download = createAsyncThunk(
    'files/download',
    async ({ uploadId, username }, { rejectWithValue, dispatch }) => {
        let tries = 20;

        const retryDownload = async () => {
            try {
                const response = await axiosInstance.post(ENDPOINTS.FILES.DOWNLOAD, {
                    data: {
                        type: 'download',
                        attributes: {
                            uploadId,
                            username,
                            rename: false,
                        },
                    },
                });

                                                                             
                return response.data;
            } catch (error) {
                if (tries === 0) {
                    throw new Error(`Failed to download: ${error.message}`);
                }
                tries -= 1;
                await new Promise(resolve => setTimeout(resolve, 250)); // Delay for retry
                return retryDownload();
            }
        };

        try {
            return await retryDownload();
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


// ================================================
// SLICE
// ================================================

const downloadSlice = createSlice({
    name: 'download',
    initialState: {
        loading: false,
        loadingTriggered: false,
        links: [],
        uploadId: null,
        files: [],
        error: null,
    },
    reducers: {
        loading: state => {
            state.loading = true;
        },
        loadingTriggered: state => {
            state.loadingTriggered = true;
        },
        complete: state => {
            state.loading = false;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(download.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(download.fulfilled, (state, action) => {
                state.loading = false;
                state.links = action.payload.data.attributes.urls;
                state.uploadId = action.payload.data.attributes.uploadId;
                state.files = action.payload.data.attributes.files;
            })
            .addCase(download.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { loading, loadingTriggered, complete } = downloadSlice.actions;
export default downloadSlice.reducer;
